"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataQuery = void 0;
class DataQuery {
    constructor(config, queryService, buildResult) {
        this.config = config;
        this.queryService = queryService;
        this.buildResult = buildResult;
    }
    /**
     * Gets query with data
     * @param data Data for query
     */
    withData(data) {
        return this.buildResult(this.config, this.queryService, data);
    }
}
exports.DataQuery = DataQuery;
//# sourceMappingURL=data-query.class.js.map